/** Mapeo ruta React Router → clave de pantalla Flow IA (backend). */

export const FLOW_IA_ROUTE_SCREEN = {
  '/': 'dashboard',
  '/employee-portal': 'employee_portal',
  '/employees': 'employees',
  '/employee-lifecycle': 'employee_lifecycle',
  '/org-chart': 'org_chart',
  '/records': 'records',
  '/documents': 'records',
  '/attendance': 'attendance',
  '/leaves': 'leaves',
  '/expense-reports': 'expense_reports',
  '/personal-finance': 'personal_finance',
  '/communications': 'communications',
  '/feed': 'feed',
  '/chat': 'chat',
  '/notifications': 'notifications',
  '/performance': 'performance',
  '/training': 'training',
  '/surveys': 'surveys',
  '/awards': 'awards',
  '/people-intelligence': 'people_intelligence',
  '/reports': 'reports',
  '/settings': 'settings',
};

export function screenFromPathname(pathname) {
  const path = pathname || '/';
  if (FLOW_IA_ROUTE_SCREEN[path]) return FLOW_IA_ROUTE_SCREEN[path];
  const base = `/${path.split('/').filter(Boolean)[0] || ''}`;
  return FLOW_IA_ROUTE_SCREEN[base] || 'dashboard';
}
